import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { OperatorOpsPageData } from "@/ui/OperatorOpsPage";
import { OperatorOpsPage } from "@/ui/OperatorOpsPage";
import { WorkspaceAdminAccessDenied, WorkspaceFetchErrorCard } from "../workspaceRouteChrome";
import { fetchJson } from "../api";

export const OperatorOpsRoute = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<OperatorOpsPageData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    document.title = t("meta.operatorOpsTitle", { appName: t("common.appName") });
  }, [t]);

  useEffect(() => {
    setError(null);
    fetchJson<OperatorOpsPageData>("/api/ui/admin/ops")
      .then(setData)
      .catch((e: unknown) => setError(e instanceof Error ? e.message : t("common.fetchFailed")));
  }, [t, refresh]);

  if (error === "Forbidden") {
    return <WorkspaceAdminAccessDenied />;
  }
  if (error) {
    return <WorkspaceFetchErrorCard error={error} onRetry={() => setRefresh((n) => n + 1)} />;
  }
  if (!data) {
    return <div className="text-muted-foreground p-6">{t("common.loading")}</div>;
  }
  return <OperatorOpsPage data={data} />;
};
